import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-monthpicker', 'months', [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь',
]);
Labels.set('ui-monthpicker', 'year', 'Год');
Labels.set('ui-monthpicker', 'month', 'Месяц');
Labels.set('ui-monthpicker', 'clearDate', 'Очистить дату');
